import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';
import RelItem from './RelItem';

export default class Predecessors extends Component {
  static propTypes = {
    producers: PropTypes.instanceOf(List),
    dispatch: PropTypes.func.isRequired,
    currentElementId: PropTypes.string.isRequired,
    existingRelationshipsArray: PropTypes.array,
    currentProjectId: PropTypes.string.isRequired,
    relationshipDirection: PropTypes.string.isRequired,
    relationshipType: PropTypes.string.isRequired,
  };

  render() {
    const {
      producers,
      dispatch,
      currentElementId,
      existingRelationshipsArray,
      currentProjectId,
      relationshipDirection,
      relationshipType,
    } = this.props;

    if (producers.size === 0) {
      return (
        <div
          style={{
            fontFamily: 'Arial',
            fontSize: 13,
          }}
        >
          <p>There are no predecessors for this element.</p>
        </div>
      );
    }

    return (
      <ul className="list-group">
        {producers.map((e, i) => (
          <RelItem
            dispatch={dispatch}
            activeElementId={currentElementId}
            existingPredecessors={existingRelationshipsArray}
            predecessor={e}
            key={i}
            currentProjectId={currentProjectId}
            relationshipDirection={relationshipDirection}
            relationshipType={relationshipType}
          />
        ))}
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/AssignPredecessorModal/Predecessors.js